import styled from 'styled-components'

export const DefaultError = styled.div`
  color: ${({ theme }) => theme.danger};
`
